
export const DECISIONS = {
  ERROR: ['error'],
  HIGH: ['oversupply', 'high'],
  INVALID: ['invalid', 'indecisive'],
  LOW: ['critical', 'insufficient', 'low', 'deficiency', 'slightly_low', 'ALLERGY_low'],
  NEGATIVE: ['negative'],
  OPTIMAL: ['optimal', 'medium', 'in-range', 'ALLERGY_no'],
  POSITIVE: ['positive'],
  PRE_RISK: ['ALLERGY_medium'],
  RISK: ['ALLERGY_high'],
  UNKNOWN: ['unknown'],
}
